import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { withApollo, compose } from 'react-apollo'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import {
  fetchUserRedeemList,
  updateUserRedeemReward
} from '../../modules/reward'
import { REDEEM_STATUS } from '../../utils/constants'

import {
  message,
  Card,
  Table,
  Divider,
  Popconfirm,
  Button,
  Input,
  Icon,
  Tag
} from 'antd'

import { useDeepEffect } from '../../utils/hooks'
import _ from 'lodash'
import Highlighter from 'react-highlight-words'
import RedeemTransactionForm from './components/RedeemTransactionForm'

const RedeemTransaction = () => {
  const dispatch = useDispatch()
  let searchInput = useRef(null)
  const [visible, setVisible] = useState(false)
  const [formData, setFormData] = useState({})
  const [searchText, setSearchText] = useState('')

  const { userRedeemItem } = useSelector(
    (state) => ({
      userRedeemItem: state.reward.userRedeemList
    }),
    []
  )

  const GetStatusColor = (status) => {
    let color = ''
    switch (status) {
      case 'DONE':
        color = 'green'
        break
      case 'WAITING':
        color = 'yellow'
        break
      case 'CANCEL':
        color = 'red'
        break
      default:
        break
    }
    return color
  }

  useDeepEffect(() => {
    async function fetch() {
      await dispatch(fetchUserRedeemList())
    }

    fetch()
  }, [])

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            searchInput = node
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}>
          Search
        </Button>
        <Button
          onClick={() => handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.select())
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  })

  const handleSearch = (selectedKeys, confirm) => {
    confirm()
    setSearchText(selectedKeys[0])
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const refetchData = async () => {}

  const onClick = (e, record) => {
    e.preventDefault()
    setVisible(true)
    setFormData(record)
  }
  const onCloseModal = async () => {
    await dispatch(fetchUserRedeemList())
    await setVisible(false)
  }

  const onOk = async (data) => {
    if (!_.isEmpty(formData)) {
      await dispatch(updateUserRedeemReward(data))
    } 
    await dispatch(fetchUserRedeemList())
    await setVisible(false)
    await setFormData({})
  }
  const columns = [
    {
      title: 'UserName',
      dataIndex: 'userName',
      key: 'userName',
      ...getColumnSearchProps('userName'),
      render: (name, row) => (
        <div>
          <Highlighter
            highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
            searchWords={[searchText]}
            autoEscape
            textToHighlight={name.toString()}
          />
        </div>
      )
    },
    {
      title: 'รางวัล',
      dataIndex: 'rewardName',
      key: 'rewardName',
      ...getColumnSearchProps('rewardName')
    },
    {
      title: 'ประเภทรางวัล',
      dataIndex: 'rewardCatagory',
      key: 'rewardCatagory',
      filters: [
        { text: 'สินค้า', value: 'สินค้า' },
        { text: 'ส่วนลด', value: 'ส่วนลด' },
        { text: 'คูปอง', value: 'คูปอง' },
        { text: 'บริจาค', value: 'บริจาค' },
      ],
      onFilter: (value, record) => record.rewardCatagory === value,
    },
    {
      title: 'วันที่แลกรางวัล',
      dataIndex: 'redeemAt',
      key: 'redeemAt',
      render: (date) => <span>{moment(date).format('DD/MM/YYYY')}</span>
    },
    {
      title: 'ที่อยู่จัดส่ง',
      dataIndex: 'userAddress',
      key: 'userAddress',
    },
    {
      title: 'สถานะ',
      dataIndex: 'status',
      key: 'status',
      filters: [
        { text: 'จัดส่งเรียบร้อย', value: 'DONE' },
        { text: 'อยู่ในระหว่างการจัดส่ง', value: 'WAITING' },
        { text: 'ยกเลิก', value: 'CANCEL' }
      ],
      onFilter: (value, record) => record.status === value,
      render: (status) => {
        const color = GetStatusColor(status)
        return (
          <span>
            <Tag color={color} key={status}>
            {status ? REDEEM_STATUS[status] : status}
            </Tag>
          </span>
        )
      }
    },
    {
      title: 'Action',
      key: 'action',
      fixed: 'right',
      width: 100,
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => {
              onClick(e, record)
            }}
          />
        </span>
      )
    }
  ]

  return (
    <Card
      title="Redeem Transaction"
      extra={
        <div>
          <Button size="small" icon="reload" onClick={() => refetchData()}>
            Reload
          </Button>
        </div>
      }>
      <Table
        scroll={{ x: 1234 }}
        rowKey={(record) => record.id}
        dataSource={userRedeemItem}
        columns={columns}
      />
      <RedeemTransactionForm
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
        formData={formData}
      />
    </Card>
  )
}

export default compose(
  withApollo
)(RedeemTransaction)



// WEBPACK FOOTER //
// ./src/pages/RedeemTransaction/index.js